import { Box, customStyled } from '@mafc/trolly';

export const ShipmentListItem = customStyled(Box)(({ theme: { radii } }) => ({
  borderRadius: `${radii[3]}px`,
  position: 'relative',
  padding: 0,
}));
